// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cCVa","right":"styles_right__l5ohY"};